import { useEffect, useState } from "react";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { GetProfile } from "../../api/get";
import { FaInfoCircle } from "react-icons/fa";
import {
  ContactPrefernce,
  ForgetPassword,
  ProfileForm,
  RemoveAccount,
} from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Common/Spinner";
import Modal from "react-responsive-modal";
import * as Yup from "yup";
import { useFormik } from "formik";
import Loader from "../../loader";
import Header from "../../Common/Header";
import { handleApiError } from "../../Common/Helper";
const Profile = () => {
  const [profileData, setProfileData] = useState([]);
  const [contentLoder, setContentLoader] = useState(true);
  // const [passwordLoading, setPasswordLoading] = useState(false);
  const [updateProfileData, setUpdateProfileData] = useState([]);
  // const [defaultValue, setDefaultValue] = useState([]);
  const [passwordChange, setPasswordChange] = useState([]);
  const [loading, setLoading] = useState(false);
  const [passwordLoader, setPasswordLoader] = useState(false);
  const [contact_prefernce, setContact_prefernce] = useState({
    contacted_by_post: 0,
    contacted_by_phone: 0,
    email_update: 0,
    contacted_by_email: 0,
  });
  const [contactLoading, setContactLoading] = useState(false);
  const [RemoveAccountLoading, setRemoveAccountLoading] = useState(false);
  const [OpenModal, setOpenModal] = useState(false);
  const [loginData, setLoginData] = useState([]);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    GetProfile()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setProfileData(res.data);
          // setDefaultValue(res.data);
          contactPreferenceFormik.setValues({
            email_update: !!res.data.email_update,
            contacted_by_email: !!res.data.contacted_by_email,
            contacted_by_phone: !!res.data.contacted_by_phone,
            contacted_by_post: !!res.data.contacted_by_post,
          });
          setContentLoader(false);
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  console.log("profileData", profileData);
  // Formik setup for profile form
  const formik = useFormik({
    initialValues: {
      email: profileData.email || "",
      first_name: profileData.first_name || "",
      last_name: profileData.last_name || "",
      contact_number: profileData.contact_number || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Email is required"),
      first_name: Yup.string().required("First Name is required"),
      last_name: Yup.string().required("Last Name is required"),
      contact_number: Yup.string()
        .matches(/^\d+$/, "Contact Number must be numeric")
        .min(10, "Contact Number must be at least 10 digits")
        .max(10, "Contact Number cannot exceed 10 digits"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      ProfileForm(values)
        .then((res) => {
          setLoading(false);
          if (res.success && res.status_code === "200") {
            const tokenData = JSON.parse(
              localStorage.getItem("willguru-token")
            );
            tokenData.first_name = res.data.first_name;
            tokenData.last_name = res.data.last_name;
            localStorage.setItem("willguru-token", JSON.stringify(tokenData));
            console.log(
              "Updated profile:",
              res.data.first_name + " " + res.data.last_name
            );
            toast.success("Profile updated successfully");
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  // Handle password change
  const passwordFormik = useFormik({
    initialValues: {
      old_password: "",
      new_password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      old_password: Yup.string()
        .required("Old password is required")
        .min(8, "Password must be at least 8 characters"),
      new_password: Yup.string()
        .required("New password is required")
        .min(8, "Password must be at least 8 characters"),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("new_password")], "Passwords do not match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values) => {
      // setPasswordLoading(true);
      ForgetPassword(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("Password Changed successfully");
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });

  // Handle password change
  const contactPreferenceFormik = useFormik({
    initialValues: {
      email_update: false,
      contacted_by_email: false,
      contacted_by_phone: false,
      contacted_by_post: false,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      email_update: Yup.boolean(),
      contacted_by_email: Yup.boolean(),
      contacted_by_phone: Yup.boolean(),
      contacted_by_post: Yup.boolean(),
    }),
    onSubmit: async (values) => {
      setContactLoading(true);
      ContactPrefernce(values)
        .then((res) => {
          setContactLoading(false);
          if (res.success && res.status_code === "200") {
            toast.success("Contact Preferences Updated");
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          setContactLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });

  // const handleProfileUpdate = (e) => {
  //   setUpdateProfileData({
  //     ...updateProfileData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  const removeAccount = () => {
    setRemoveAccountLoading(true);
    RemoveAccount()
      .then((res) => {
        console.log(res);
        if (res.success && res.status_code === "200") {
          setRemoveAccountLoading(false);
          setOpenModal(false);
          toast.success("Your Account Removed Successfully");
          setTimeout(() => {
            navigate("/");
          }, [2000]);
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((err) => {
        setRemoveAccountLoading(false);
        setOpenModal(false);
        console.log(err);
      });
  };

  // const onChangePassword = (e) => {
  //   setPasswordChange({ ...passwordChange, [e.target.name]: e.target.value });
  // };
  // const validate = () => {
  //   const newErrors = {};
  //   // Email Validation
  //   if (!passwordChange.old_password) {
  //     newErrors.old_password = "Old Password is required";
  //   }
  //   if (!passwordChange.new_password) {
  //     newErrors.new_password = "New password is required";
  //   } else {
  //     if (!passwordChange.confirm_password) {
  //       newErrors.confirm_password = "Confirm password is required";
  //     } else if (
  //       passwordChange.confirm_password !== passwordChange.new_password
  //     ) {
  //       newErrors.confirm_password = "Passwords do not match";
  //     }
  //   }

  //   // Confirm Password Validation

  //   return newErrors;
  // };
  // const handleSubmitChangePassword = (e) => {
  //   e.preventDefault();
  //   const validationErrors = validate();
  //   if (Object.keys(validationErrors).length > 0) {
  //     setErrors(validationErrors);
  //   } else {
  //     setPasswordLoader(true);
  //     ForgetPassword(passwordChange)
  //       .then((res) => {
  //         console.log(res);
  //         if (res.success === true) {
  //           toast.success("Password Change Successfully");
  //           setPasswordLoader(false);
  //           setTimeout(() => {
  //             window.location.reload();
  //           }, 1000);
  //         } else {
  //           setPasswordLoader(false);
  //           toast.error("Fill all correct detials");
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         setPasswordLoader(false);
  //         toast.error("Fill all correct detials");
  //       });
  //   }
  // };
  // const handleKeyPress2 = (event) => {
  //   if (event.key === "Enter") {
  //     handleSubmitChangePassword(event); // Manually trigger the submit on Enter key
  //   }
  // };
  const handleContactPrefernce = () => {
    setContactLoading(true);
    ContactPrefernce(contact_prefernce)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          console.log(res);
          setContactLoading(false);
          toast.success("Contact Prefernce Updated");
          setTimeout(() => {
            window.location.reload();
          }, [2500]);
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((err) => {
        console.log(err);
        setContactLoading(false);
        toast.error("Fill correct details");
      });
  };

  return (
    <>
      {contentLoder ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 max-lg:grid-cols-1">
              <div className="w-full max-w-[80%] max-md:max-w-full">
                <div className="my-4">
                  <h4 className="font-bold text-[24px] sm:text-[30px] lg:text-[34px]">
                    Your profile
                  </h4>
                  <p className="text-[14px] text-slate-500 font-muli">
                    Check and update your personal information and account
                    settings
                  </p>
                </div>
                <div>
                  <p className="my-3 font-bold text-[20px] sm:text-[26px] lg:text-[30px]">
                    Personal details
                  </p>
                  <form onSubmit={formik.handleSubmit}>
                    <div className="mt-4">
                      <FloatingLabelInput
                        label="Email"
                        type="email"
                        id="email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>

                    {formik.touched.email && formik.errors.email ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {formik.errors.email}
                        </p>
                      </div>
                    ) : null}
                    <div className="mt-4">
                      <FloatingLabelInput
                        label="First Name"
                        type="first_name"
                        id="first_name"
                        name="first_name"
                        value={formik.values.first_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                    {formik.touched.first_name && formik.errors.first_name ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {formik.errors.first_name}
                        </p>
                      </div>
                    ) : null}
                    <div className="mt-4">
                      <FloatingLabelInput
                        label="Last Name"
                        type="last_name"
                        id="last_name"
                        name="last_name"
                        value={formik.values.last_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                    {formik.touched.last_name && formik.errors.last_name ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {formik.errors.last_name}
                        </p>
                      </div>
                    ) : null}
                    <div className="mt-4">
                      <FloatingLabelInput
                        label="Contact Number"
                        type="Contact Number"
                        id="Contact Number"
                        name="contact_number"
                        value={formik.values.contact_number}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                    {formik.touched.contact_number &&
                    formik.errors.contact_number ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {formik.errors.contact_number}
                        </p>
                      </div>
                    ) : null}
                    <div>
                      {loading ? (
                        <button className="bg-primary  text-white px-5 py-3 rounded-lg my-5 ">
                          <Spinner />
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="bg-primary  text-white px-5 py-3 rounded-lg my-5 font-bold"
                        >
                          Update
                        </button>
                      )}
                    </div>
                  </form>
                </div>
                <div>
                  <p className="my-3 font-bold text-[20px] sm:text-[26px] lg:text-[30px]">
                    Change your password
                  </p>
                  <form onSubmit={passwordFormik.handleSubmit}>
                    <div className="mt-4">
                      <FloatingLabelInput
                        label="Old Password"
                        type="password"
                        id="old_password"
                        name="old_password"
                        value={passwordFormik.values.old_password}
                        onChange={passwordFormik.handleChange}
                        onBlur={passwordFormik.handleBlur}
                      />
                    </div>
                    {passwordFormik.touched.old_password &&
                    passwordFormik.errors.old_password ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {passwordFormik.errors.old_password}
                        </p>
                      </div>
                    ) : null}
                    <div className="mt-4">
                      <FloatingLabelInput
                        label="New Password"
                        type="password"
                        id="new_password"
                        name="new_password"
                        value={passwordFormik.values.new_password}
                        onChange={passwordFormik.handleChange}
                        onBlur={passwordFormik.handleBlur}
                      />
                    </div>
                    {passwordFormik.touched.new_password &&
                    passwordFormik.errors.new_password ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {passwordFormik.errors.new_password}
                        </p>
                      </div>
                    ) : null}
                    <div className="mt-4">
                      <FloatingLabelInput
                        label="Confirm new Password"
                        type="password"
                        id="confirm_password"
                        name="confirm_password"
                        value={passwordFormik.values.confirm_password}
                        onChange={passwordFormik.handleChange}
                        onBlur={passwordFormik.handleBlur}
                      />
                    </div>
                    {passwordFormik.touched.confirm_password &&
                    passwordFormik.errors.confirm_password ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {passwordFormik.errors.confirm_password}
                        </p>
                      </div>
                    ) : null}

                    <div>
                      {passwordLoader ? (
                        <button className="bg-primary  text-white px-5 py-3 rounded-lg my-5 ">
                          <Spinner />
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="bg-primary  text-white px-5 py-3 rounded-lg my-5 font-bold"
                        >
                          Update
                        </button>
                      )}
                    </div>
                  </form>
                </div>
                <form onSubmit={contactPreferenceFormik.handleSubmit}>
                  <h3 className="font-bold my-3 text-[20px] sm:text-[26px] lg:text-[30px]">
                    Contact Preferences
                  </h3>
                  <div className="flex items-center mt-2 mb-4">
                    <input
                      type="checkbox"
                      id="email_update"
                      name="email_update"
                      checked={contactPreferenceFormik.values.email_update}
                      onChange={() =>
                        contactPreferenceFormik.setFieldValue(
                          "email_update",
                          !contactPreferenceFormik.values.email_update
                        )
                      }
                      className="mr-2"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <label
                      htmlFor="email_update"
                      className="text-[16px] text-black dark:text-gray-300 font-muli"
                    >
                      You opted in to marketing. To opt out, uncheck this box.
                    </label>
                  </div>
                  <p className="text-[16px] text-black dark:text-gray-300 font-muli">
                    Yes, I am happy to share the details of my charitable
                    donations with the charities involved.
                  </p>
                  <div className="flex items-center mt-5 mb-4">
                    <input
                      type="checkbox"
                      id="contacted_by_email"
                      name="contacted_by_email"
                      checked={
                        contactPreferenceFormik.values.contacted_by_email
                      }
                      onChange={() =>
                        contactPreferenceFormik.setFieldValue(
                          "contacted_by_email",
                          !contactPreferenceFormik.values.contacted_by_email
                        )
                      }
                      className="mr-2"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <label htmlFor="contacted_by_email" className="text-black">
                      Email
                    </label>
                  </div>
                  <div className="flex items-center mt-2 mb-4">
                    <input
                      type="checkbox"
                      id="contacted_by_phone"
                      name="contacted_by_phone"
                      checked={
                        contactPreferenceFormik.values.contacted_by_phone
                      }
                      onChange={() =>
                        contactPreferenceFormik.setFieldValue(
                          "contacted_by_phone",
                          !contactPreferenceFormik.values.contacted_by_phone
                        )
                      }
                      className="mr-2"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <label htmlFor="contacted_by_phone" className="text-black">
                      Phone
                    </label>
                  </div>
                  <div className="flex items-center mt-2 mb-4">
                    <input
                      type="checkbox"
                      id="contacted_by_post"
                      name="contacted_by_post"
                      checked={contactPreferenceFormik.values.contacted_by_post}
                      onChange={() =>
                        contactPreferenceFormik.setFieldValue(
                          "contacted_by_post",
                          !contactPreferenceFormik.values.contacted_by_post
                        )
                      }
                      className="mr-2"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <label htmlFor="contacted_by_post" className="text-black">
                      Post
                    </label>
                  </div>
                  <button
                    type="submit"
                    className="bg-primary text-white px-5 py-3 rounded-lg my-5 font-bold"
                  >
                    {contactLoading ? <Spinner /> : "Update Preferences"}
                  </button>
                </form>
                <div className="my-4">
                  <h4 className="my-3 font-bold text-[20px] sm:text-[26px] lg:text-[30px]">
                    Remove your account
                  </h4>
                  <p className="text-[16px] text-slate-500 font-muli">
                    Removing your account deletes all information associated
                    with your profile including any documents or memorials
                    created. Please note, this action is not reversible.
                  </p>
                </div>

                <div>
                  <button
                    onClick={() => {
                      setOpenModal(true);
                    }}
                    className="bg-primary text-white px-5 py-3 rounded-lg my-5 font-bold"
                  >
                    Remove my account
                  </button>
                  <Modal open={OpenModal} onClose={() => setOpenModal()} center>
                    <div className={"w-[500px] max-xl:w-auto"}>
                      <div className="p-5">
                        <h2 className="text-center text-[30px] font-bold">
                          Are you sure?
                        </h2>
                        <p className="text-center text-slate-500 pb-5">
                          You cannot undo this step after you've done it.
                        </p>
                      </div>
                      <div className="flex gap-4">
                        <button
                          onClick={() => setOpenModal(false)}
                          className="border-2 w-full rounded-[5px] bg-primary text-white border-[#240642] text-[#240642] px-4 py-1 font-bold"
                        >
                          No, Keep my account
                        </button>
                        {RemoveAccountLoading ? (
                          <button className="border-2 flex justify-center w-full rounded-[5px] border-[#240642] bg-primary text-[#240642] px-4 py-1 font-bold">
                            <Spinner />
                          </button>
                        ) : (
                          <button
                            onClick={() => removeAccount()}
                            className="border-2 w-full rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                          >
                            Yes, delete my account
                          </button>
                        )}
                      </div>
                    </div>
                  </Modal>
                </div>
              </div>
              <div className="max-lg:hidden bg-no-repeat">
                <div className="fixed top-0 w-[500px] right-[6%] bg-cloud">
                  <img src="/assets/images/4.png" alt="mascot" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Profile;
